export default (store) => ({
  path : 'orders/:id(/:tab)',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    import(
      /* webpackChunkName: 'orders' */
      './components/OrderDetails'
    ).then(module => {
      cb(null, module.default)
    })
  }
})
